import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/tool-categories/_list/$categoryId/",
)({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
